// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinnerContainer":"LoadingSpinner_loadingSpinnerContainer__nhUCR","centered":"LoadingSpinner_centered__KOxYn"};